import { render, staticRenderFns } from "./bsp-dialog.vue?vue&type=template&id=56108cc6&scoped=true&"
import script from "./bsp-dialog.vue?vue&type=script&lang=js&"
export * from "./bsp-dialog.vue?vue&type=script&lang=js&"
import style0 from "./bsp-dialog.vue?vue&type=style&index=0&id=56108cc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56108cc6",
  null
  
)

export default component.exports